import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./mobile_header.module.css";
import AsideMenu from "../aside_menu/aside_menu";

import { SHOP_NAME } from "../../../utils/constants";

function MobileHeader() {

  const [checkMenu, setCheckMenu] = useState(false);
  const [checkTelList, setCheckTelList] = useState(false);

  const handleChecked = () => {
    setCheckMenu(!checkMenu);
    if (checkTelList) {
      handleCheckTelList();
    }
  }

  const handleCheckTelList = () => {
    setCheckTelList(!checkTelList);
    if (checkMenu) {
      handleChecked();
    }
  }

  const handleCloseAlMenu = () => {
    setCheckMenu(false);
    setCheckTelList(false);
  }

  return (
    <header className={`${styles.header}`}>
      <Link className={`${styles.shopName}`}
        onClick={handleCloseAlMenu}
        to="/"
      >
        {SHOP_NAME}
      </Link>
      <div className={styles.menuStart}>
        <AsideMenu />
      </div>
    </header>
  );
}

export default MobileHeader;
